"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CJitStateEnum = void 0;
var CJitStateEnum;
(function (CJitStateEnum) {
    /**
     * Invoice is ready to receive funds.
     */
    CJitStateEnum["CREATED"] = "created";
    /**
     * Channel opened and funds pushed to client.
     */
    CJitStateEnum["COMPLETED"] = "completed";
    /**
     * Invoice expired.
     */
    CJitStateEnum["EXPIRED"] = "expired";
    /**
     * Channel open failed.
     */
    CJitStateEnum["FAILED"] = "failed";
})(CJitStateEnum = exports.CJitStateEnum || (exports.CJitStateEnum = {}));
//# sourceMappingURL=CJitStateEnum.js.map